<template>
    <div class="row">
        <div class="col">
            <div v-if="error" class="alert alert-danger">
                <div>{{ errorList }}</div>
            </div>
            <div class="row" v-if="products && products.length">
                <div class="col-lg-4 col-md-6 col-sm-6" v-for="product in products" v-bind:key="product.productId">
                    <a v-bind:href="product.Url" class="single-product animated fadeIn">
                        <div class="prod-img">
                            <img v-bind:src="product.Foto" v-bind:alt="product.Merk + ' ' + product.Naam" />
                        </div>
                        <div class="product-details">
                            <div class="title">
                                <h5>{{product.Merk}}</h5>
                                <h4>{{product.Naam}}</h4>
                            </div>
                            <div class="price">
                                <span v-if="product.Prijs != ''">Vanaf</span>
                                <span class="prijs">{{product.Prijs}}</span>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Products',
        computed: {
            products() {
                return this.$store.state.products.Products;
            },            
            loading() {
                return this.$store.state.loadingStatus === 'notloading'
            },
            error() {
                return this.$store.state.errors.length > 0;
            },
            errorList() {
                return this.$store.state.errors;
            }
        }
    }
</script>